const { Limelight } = window;

const ThemeSections = require('@shopify/theme-sections');

const Cookie = require('js-cookie');


exports.default = () => {
  ThemeSections.register('theme-popups', {
    onLoad: function onLoad() {
      var popupElements = this.container.querySelectorAll('[data-popup-dynamic]');
      var editingMode = JSON.parse(this.container.dataset.popupEditingMode);
      window.dynamicPopups = [];

      popupElements.forEach(function (popup, index) {
        var _popup$dataset = popup.dataset,
            popupDynamic = _popup$dataset.popupDynamic,
            popupDelay = _popup$dataset.popupDelay,
            popupExpiry = _popup$dataset.popupExpiry;

        var delay = Number(popupDelay);
        var expiry = Number(popupExpiry);

        dynamicPopups[index] = new Limelight('#' + popup.id, {
          bodyClass: 'active-popup',
          hideCallback: function hideCallback(element, elements) {
            Cookie.set(element.element.id, true, { expires: expiry });
          }
        });

        if (editingMode) {
          Cookie.remove(popup.id);
        }

        if (Cookie.get(popup.id) == null) {
          setTimeout(function () {
            dynamicPopups[index].show();
          }, delay);
        }
      }.bind(this));
    },
    onBlockSelect: function onBlockSelect(id) {
      Limelight.elements['#PopupDynamic_' + id].show();
    },
    onBlockDeselect: function onBlockDeselect(id) {
      Limelight.elements['#PopupDynamic_' + id].hide();
    }
  });
};
